import { Avatar, Button, List, Popup, SearchBar, SpinLoading } from 'antd-mobile'
import { AddCircleOutline, SearchOutline } from 'antd-mobile-icons'
import { useState } from 'react'
import ClientForm from './ClientForm'
import { clearSearchResult, searchBusinessClient } from '../../redux/actions/businessClient/businessClient'
import { getAsYouType } from 'awesome-phonenumber'
import { useDispatch, useSelector } from 'react-redux'
import { Empty } from 'antd'
import { safeParse } from "../../utils/utility"
// import { nationalFormatPhone } from '../../utils/FormatPhoneNumber/FormatPhoneNumber'

const ClientSearch = (props) => {
    const [visible, setVisible] = useState(false)
    const [clientFormVisible, setClientFormVisible] = useState(false)
    const [formatSearchText, setFormatSearchText] = useState('')
    const [typingTimeout, setTypingTimeout] = useState(0)
    const dispatch = useDispatch()
    const country = safeParse("business")?.country || "CA"
    const { clients, loading } = useSelector((state) => state.businessClient)

    const handleSearch = (value) => {
        let formatSearchText = value.replace(/\s+/g, " ");
        searchClient(formatSearchText, typingTimeout)
        if (!formatSearchText) {
            dispatch(clearSearchResult());
        }
    }

    const searchClient = (formatSearchText, typingTimeOut) => {
        let query = "";

        const format = /^[^a-zA-Z]*$/;

        // Clear the timeout when the user is typing
        if (typingTimeOut) {
            clearTimeout(typingTimeOut);
        }

        // Check if the input is text or number
        if (format.test(formatSearchText)) {
            const ayt = getAsYouType(country);
            formatSearchText = ayt.reset(formatSearchText.replace(/[^\w]/g, ''));
            query = `search=${formatSearchText.replace(/[^\w]/g, '')}`;
        } else {
            query = `search=${formatSearchText}`;
        }

        // Count digits and letters
        const digitCount = (formatSearchText.match(/\d/g) || []).length;
        const letterCount = (formatSearchText.match(/[a-zA-Z]/g) || []).length;

        setTypingTimeout(
            formatSearchText &&
            (digitCount > 5 || letterCount >= 3) &&
            setTimeout(() => {
                dispatch(searchBusinessClient(query));
            }, 500)
        );

        setFormatSearchText(formatSearchText);
    };

    const onChooseClient = (client) => {
        props.setCurrentClient(client)
        setVisible(false)
    }

    return (
        <div style={{ margin: "12px" }}>
            <Button
                style={{}}
                block
                size='large'
                color='primary'
                fill='outline'
                shape='rounded'
                onClick={() => {
                    setVisible(true)
                }}
            >
                <SearchOutline /> Search Client
            </Button>
            <Popup
                position='left'
                visible={visible}
                showCloseButton
                onClose={() => {
                    setVisible(false)
                }}
            >
                <div style={{ width: '100vw', padding: '10px' }}>
                    <h1>Search Client</h1>
                    <SearchBar
                        value={formatSearchText}
                        onChange={handleSearch}
                        placeholder='Phone number or name'
                        style={{
                            '--border-radius': '100px',
                            '--height': '48px',
                            '--padding-left': '12px',
                            '--background': '#eeeef7',
                        }}
                        clearable />
                    <Button style={{ marginTop: "10px" }} color='primary' fill='none' onClick={() => setClientFormVisible(true)}>
                        <AddCircleOutline /> Create New Client
                    </Button>
                    <Popup
                        position='left'
                        visible={clientFormVisible}
                        showCloseButton
                        destroyOnClose
                        onClose={() => {
                            setClientFormVisible(false)
                        }}
                    >
                        <div style={{ width: '100vw', padding: '10px' }}>
                            <ClientForm setClientFormVisible={setClientFormVisible} setVisible={setVisible} setCurrentClient={props.setCurrentClient} />
                        </div>
                    </Popup>

                    {loading
                        ? <div style={{ width: '100%', display: "flex", justifyContent: "center", alignItems: "center", paddingTop: '100px' }}>
                            <SpinLoading style={{ '--size': '32px' }} />
                        </div>
                        : clients.length > 0
                            ? <List style={{ marginTop: '10px' }}>
                                {clients.map(client => (
                                    <List.Item
                                        onClick={() => onChooseClient(client)}
                                        key={client.phone}
                                        prefix={
                                            <Avatar
                                                src=''
                                                style={{ '--border-radius': '50%' }}
                                            />
                                        }
                                        description={client.phone ? <span>••••{client.phone?.slice(-4)}</span> : "Unknown"}
                                    >
                                        {client.firstName || client.lastName ? client.firstName + " " + client.lastName : "Unknown"}
                                    </List.Item>
                                ))}
                            </List>
                            : <div style={{ marginTop: "20px" }}>
                                <Empty description='No client' />
                            </div>
                    }
                </div>
            </Popup>
        </div>
    )
}

export default ClientSearch